export default {
	timeFormat: function(str) {
		if(!str) {
			return ""
		}
		let year = str.substring(0,4);
		let month = str.substring(5,7);
		let day = str.substring(8,10);
		return year + "年" + month + "月" + day + "日"
	}
}


// WEBPACK FOOTER //
// ./src/util/util.js